import React from 'react'
import {
  Edit,
  SimpleForm,
  TextInput,
  required
} from 'react-admin'

const GraduateProgramEdit = (props) => (
  <Edit {...props}>
    <SimpleForm>
      <TextInput source="name" validate={[required()]} />
    </SimpleForm>
  </Edit>
)

export default GraduateProgramEdit
